import { render, staticRenderFns } from "./SelectFieldMultipleChips.vue?vue&type=template&id=64a7c08b"
import script from "./SelectFieldMultipleChips.vue?vue&type=script&lang=js"
export * from "./SelectFieldMultipleChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports